import { useCallback, useMemo } from 'react';
import { RackingArea } from '@thive/fddm-types';

import { SelectInput } from '@common/components/inputs';
import { useReadSelectedAreas } from '@/modules/floorplanDesign/hooks';
import { areasToFlatCollection, isRackingArea } from '@/modules/floorplanDesign/helpers';
import { FddmServiceFactory } from '@/modules/canvas/services/Floorplan/FddmServiceFactory';

const LOAD_HANDLING_TYPE_OPTIONS: {
  label: string;
  value: RackingArea['rackingLoadHandlingType'];
}[] = [
  { label: 'Intake', value: 'INTAKE' },
  { label: 'Storage', value: 'STORAGE' },
  { label: 'Delivery', value: 'DELIVERY' },
];

function RackingLoadHandlingType() {
  const selectedAreas = useReadSelectedAreas();
  const fddmSvc = useMemo(() => FddmServiceFactory.getInstance().createFddmService(), []);

  const rackingAreaType = useMemo(() => {
    const areas = areasToFlatCollection(selectedAreas);
    if (areas.length !== 1) return;
    const area = areas[0];
    if (!isRackingArea(area)) return;

    const { rackingLoadHandlingType } = area;
    return rackingLoadHandlingType;
  }, [selectedAreas]);

  const onChange = useCallback(
    (newValue: RackingArea['rackingLoadHandlingType']) => {
      const areas = areasToFlatCollection(selectedAreas);
      if (areas.length !== 1) return;
      const area = areas[0];
      if (!isRackingArea(area)) return;
      fddmSvc.setPreference('rackingArea.rackingLoadHandlingType', newValue);
      fddmSvc.updateArea({
        ...area,
        rackingLoadHandlingType: newValue,
      });
    },
    [selectedAreas, fddmSvc],
  );

  if (rackingAreaType === undefined) return null;

  return (
    <SelectInput options={LOAD_HANDLING_TYPE_OPTIONS} onChange={onChange} value={rackingAreaType} />
  );
}

export default RackingLoadHandlingType;
